import { fetchMissions, addMission, updateMission, deleteMission, } from '@/features/mission/services/missionService';
import { useMutation, useQuery, useQueryClient } from "react-query";
const useMissions = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    // Use react-query to fetch missions based on page, filters, and the "all" flag.
    const { data, error, isLoading, refetch, } = useQuery(['missions', { page, filters, all, limit }], () => fetchMissions(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 60 * 60000, // data is fresh for 60 * 60 seconds
    });
    // Mutation for adding a mission.
    const addMissionMutation = useMutation((mission) => addMission(mission), {
        onSuccess: () => {
            queryClient.invalidateQueries('missions');
        },
    });
    // Mutation for updating a mission.
    const updateMissionMutation = useMutation((mission) => updateMission(mission), {
        onSuccess: () => {
            queryClient.invalidateQueries('missions');
        },
    });
    // Mutation for deleting a mission.
    const deleteMissionMutation = useMutation((missionId) => deleteMission(missionId), {
        onSuccess: () => {
            queryClient.invalidateQueries('missions');
        },
    });
    return {
        missions: data?.missions || [],
        missionMetaData: data?.meta || null,
        missionsLoading: isLoading,
        missionError: error ? error.message : null,
        // Mutations
        handleAddMission: addMissionMutation.mutateAsync,
        handleUpdateMission: updateMissionMutation.mutateAsync,
        handleDeleteMission: deleteMissionMutation.mutateAsync,
        // For refreshing data manually
        refetchMissions: refetch,
    };
};
export default useMissions;
